export const serviceId = "service_8muqwgv";
export const templateId = "template_zgsi7z6";
export const userId = "OnsYyOBbCW1eQ0R28";
